import { Button } from "@mantine/core";
import { useAppDispatch } from "@/store/hooks";
import { setProductMatchConfirmed, setSelectedProductId } from "@/store";

export const OosPlanogramModalActions = ({
  onClose,
  onSave,
  selectedProductId,
}: {
  onClose: () => void;
  onSave: () => void;
  selectedProductId: string;
}) => {
  const dispatch = useAppDispatch();

  const handleConfirmItem = async () => {
    dispatch(setProductMatchConfirmed(true));
    dispatch(setSelectedProductId(selectedProductId));
    onSave();
  };

  return (
    <div className="inline-flex justify-end gap-2 absolute bottom-0 right-0 z-50 p-2">
      <Button style={{ minWidth: 100 }} variant="outline" onClick={onClose}>
        Exit
      </Button>
      <Button style={{ minWidth: 100 }} onClick={handleConfirmItem}>
        Save
      </Button>
    </div>
  );
};
